import React from 'react';
import * as $ from 'jquery';
import DataTable from 'datatables.net';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';

class DataTabel extends React.Component {

  componentDidMount(){
    const tableElement = $('#'+this.props.input_id);
      tableElement.DataTable({
        data: this.props.input_value,
        columns: this.props.input_columns
      });
  }

  render() {

    return (
        <table id={this.props.input_id} className="display" style={{width: '100%'}}></table>
    );
  }
}

export { DataTabel };


// WEBPACK FOOTER //
// ./src/components/DataTabel.jsx